import { atom } from 'nanostores'
import { type MouseEvent, type MutableRefObject, useEffect } from 'react'

import type { ScheduledMessage } from '../../types'

import css from './Messages.module.css'

const $active = atom<null | ScheduledMessage>(null)

let popover: HTMLElement | null = null
let trigger: HTMLElement | null = null
function openFromTrigger(
	event: MouseEvent<HTMLButtonElement>,
	message: ScheduledMessage
) {
	const current = $active.get()

	const isSameValue = message.id === current?.id
	const trigger = event.currentTarget

	if (current && !isSameValue) {
		popover?.addEventListener(
			'toggle',
			() => openWithAnchor(trigger, message),
			{ once: true }
		)
	}

	if (current) {
		return popover?.hidePopover()
	}

	openWithAnchor(trigger, message)
}

function openWithAnchor(element: HTMLElement, message: ScheduledMessage) {
	trigger = element
	trigger.classList.add(css.currentTrigger)

	$active.set(message)
	popover?.showPopover()
}

function syncClose(event: ToggleEvent) {
	if (event.newState === 'closed') {
		trigger?.classList.remove(css.currentTrigger)
		$active.set(null)
	}
}

function useSyncPopoverState(ref: MutableRefObject<HTMLElement | null>) {
	useEffect(() => {
		if (!ref.current) {
			return
		}

		popover = ref.current
		// @ts-expect-error
		popover.addEventListener('toggle', syncClose)

		return () => {
			// @ts-expect-error
			popover.removeEventListener('toggle', syncClose)

			popover = null
			trigger = null
		}
	}, [ref])
}

export { $active, openFromTrigger, useSyncPopoverState }
